import PropTypes from 'prop-types';

import Box from '@zenbusiness/zui/Box';
import { styled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

import { PRODUCT_CARD_STATUS } from '../../constants';

function getBadgeLabel(badge) {
  switch (badge) {
    case PRODUCT_CARD_STATUS.FREE.state:
      return PRODUCT_CARD_STATUS.FREE.label;
    default:
      return null;
  }
}
export const ProductCardBadge = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.purple.light,
  borderRadius: `${theme.shape.rounded.none} ${theme.shape.rounded.md}`,
  padding: `${theme.spacing(0.25)} ${theme.spacing(2)}`,
  position: 'absolute',
  right: '0',
  top: '0'
}));

function Badge({ badge }) {
  const isPurchased = badge?.state === PRODUCT_CARD_STATUS.PURCHASED.state;
  const isRequested = badge?.state === PRODUCT_CARD_STATUS.REQUESTED.state;

  if (!badge || isPurchased || isRequested) {
    return null;
  }

  return <ProductCardBadge><Text weight="medium" size="xs">{getBadgeLabel(badge.state)}</Text></ProductCardBadge>;
}

Badge.propTypes = {
  badge: PropTypes.shape({
    state: PropTypes.string,
    label: PropTypes.string
  })
};

export default Badge;
